
import { Component, OnInit, OnDestroy, Input, AfterContentChecked } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { GeneralService } from '../../services/general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { AppLoadingService } from '../../services/apploading.service';
import { AbstractForm } from '../../utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { Subscription } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { RealtorController } from 'src/app/modules/realtor/realtor.controller';

declare var $: any;

@Component({
  selector: 'dialog-preferences',
  templateUrl: './dialog-preferences.component.html',
  styleUrls: ['./dialog-preferences.component.scss']
})
export class DialogPreferencesComponent extends AbstractForm implements OnInit, OnDestroy, AfterContentChecked {

  @Input() state: any = '';

  formGroup: FormGroup;
  preferencesFormGroup: FormGroup;

  loading = true;
  submitted = false;

  personData: any = [];

  cities: any = [];
  citiesLoaded = false;
  citiesSelected: any = [];

  userdata: any = {};
  userAllow = false;


  protected personDataSubscription: Subscription;

  constructor(
    public gs: GeneralService,
    protected httpService: HttpService,
    logger: LoggerService,
    private auth: AuthService,
    protected als: AppLoadingService,
    protected formBuilder: FormBuilder,
    private control: RealtorController,
    private dialogRef: MatDialogRef<DialogPreferencesComponent>) {
    super(formBuilder, logger);



  }

  getUserdata() {
    return this.auth.getUserdata();
  }

  ngOnInit() {

    this.preferencesFormGroup = this.formBuilder.group({
      cityMain: ['', [Validators.required]],
      cityInterest: this.formBuilder.group({})
    });

    this.personDataSubscription = this.gs.generalData$.subscribe((result) => {
      if (!!result?.person?.length) {
        this.personData = result?.person[0];
        this.adjustCities(result?.adCities?.states);
      }
    });
    this.userAllow = this.gs.getSignUpState() == 'AccessAllow';

  }

  ngOnDestroy() {
    this.personDataSubscription.unsubscribe();
  }

  ngAfterContentChecked() {
    this.setTooltip();
    this.loading = false;
  }
  setTooltip() {
    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover'
    });
  }

  compareFn(c1: any, c2: any): boolean {
    if (c2 === null)
      return false;

    return c1?.id == c2?.id || c1?.id == c2 || c1 == c2?.id;
  }


  updateControls() { }
  updateObject(): any { }

  /*
      PREFERENCES
  */


  adjustCities(cities: any) {

    let group = {};
    let states = cities?.buckets;
    let res = [];
    if (!states)
      return;

    if (typeof this.personData?.cities == 'string')
      this.personData.cities = JSON.parse(this.personData.cities);

    this.personData?.cities?.map(item => {
      this.citiesSelected.push(item.city_id.toString());
      if (item?.main)
        this.setControlValue('cityMain', { id: item.city_id.toString() }, this.preferencesFormGroup);
    });

    states.forEach((v, k) => {
      if (typeof res[k] === 'undefined')
        res[k] = { title: v.key, items: [] };

      v.cities.buckets.map(city => {
        let id = city.cityId.buckets[0].key;
        res[k].items.push({ id: id, title: city.key });
        group['city_' + id] = [this.citiesSelected.indexOf(id) > -1];
      });
      res[k].items = res[k].items.sort((a, b) => a.title.localeCompare(b.title));

    });

    res = res.sort((a, b) => a.title.localeCompare(b.title));

    this.preferencesFormGroup.controls.cityInterest = this.formBuilder.group(group);

    this.cities = res;

    this.citiesLoaded = true;
    setTimeout(() => this.setTooltip(), 200);
  }

  changeCitySelect(ev) {
    let checks = this.getFormValues(this.preferencesFormGroup).cityInterest;
    this.citiesSelected = [];
    for (let k in checks)
      if (checks.hasOwnProperty(k) && checks[k] == true)
        this.citiesSelected.push(k.substr(k.indexOf('_') + 1));

    if (this.citiesSelected.indexOf(this.getControlValue('cityMain', this.preferencesFormGroup)?.id) == -1)
      this.setControlValue('cityMain', '', this.preferencesFormGroup);

    let cityMainValue = this.preferencesFormGroup.controls.cityMain.value;
    this.preferencesFormGroup.removeControl('cityMain');
    this.preferencesFormGroup.addControl('cityMain', new FormControl(cityMainValue, !!this.citiesSelected?.length? [Validators.required] : []));    

    this.markAllTouched(this.preferencesFormGroup);

  }

  sendPreferences() {
    let values = this.getFormValues(this.preferencesFormGroup);

    let cityInterest = [];
    for (let k in values.cityInterest)
      if (values.cityInterest.hasOwnProperty(k) && values.cityInterest[k] == true) {
        let id = k.substr(k.indexOf('_') + 1);
        let item: any = { city_id: id };
        if (id == values.cityMain?.id)
          item.main = true;

        cityInterest.push(item);
      }

    let nv = { cities: cityInterest };

    this.httpService.put<any>(API.profile.general.preferences, nv)
      .then(result => {
        this.gs.error({}, 'Preferências salvas com sucesso');

        this.gs.doConfirmSignedIn(this.state == 'CitiesPreferenceRequired');
      })
      .catch((err) => this.gs.error(err))
      ;
  }

}
